import { render, staticRenderFns } from "./BagProducts.vue?vue&type=template&id=1ca9de15&scoped=true"
import script from "./BagProducts.vue?vue&type=script&lang=js"
export * from "./BagProducts.vue?vue&type=script&lang=js"
import style0 from "./BagProducts.vue?vue&type=style&index=0&id=1ca9de15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca9de15",
  null
  
)

export default component.exports